(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/logout/assets/javascript/prescript.js') >= 0) return;  svs.modules.push('/modules/logout/assets/javascript/prescript.js');

'use strict';

svs.logout = svs.logout || {};
svs.logout.data = svs.logout.data || {};
svs.logout.data.uris = svs.logout.data.uris || {};

 })(window);